import type { AzureBlock } from "./shared";

export function blockifyFile(file: File, chunkSize: number): AzureBlock[] {
  const blocks: AzureBlock[] = [];
  let offset = 0;
  while (offset < file.size) {
    const chunk = file.slice(offset, offset + chunkSize);
    const index = blocks.length + 1;
    blocks.push({
      id: index,
      data: chunk,
    });
    offset += chunkSize;
  }
  return blocks;
}
